import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPlus = () => {
  return (
    <g>
      <path d="M8 1a.75.75 0 0 1 .75.75v5.5h5.5a.75.75 0 1 1 0 1.5h-5.5v5.5a.75.75 0 1 1-1.5 0v-5.5h-5.5a.75.75 0 0 1 0-1.5h5.5v-5.5A.75.75 0 0 1 8 1z" />
    </g>
  );
};

export default withIcon(IconPlus);
